/* Package JSON Import will be here */
import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
/* Package JSON Import will be here */

/* Project Import will be here */
import loginReducer from './login.Reducer';
import deviceReducer from './device.Reducer';
import tabReducer from './tab.Reducer';
import timeCardDatasReducer from './timeCardDatas.Reducer';
import dateReducer from './date.Reducer';
import defaultGroupByReducer from './timecardDefaultGroupBy.Reducer';
import historyReducer from './history.Reducer';
import projectAndTaskReducer from './projectAndTask.Reducer';
import tmVoucherReducer from './tmVoucher.reducer';
import lastSavedPunches from './lastSavedPunches.Reducer';
/* Project Import will be here */   

export default combineReducers({
    router: routerReducer,
    loginReducer,
    deviceReducer,
    tabReducer,
    timeCardDatasReducer,
    dateReducer,
    defaultGroupByReducer,
    historyReducer,
    projectAndTaskReducer,
    tmVoucherReducer,
    lastSavedPunches
});